import { Controller } from "@hotwired/stimulus"
import FanwordLightbox from '../scripts/lightbox';

export default class extends Controller {

  connect() {
    // console.log("Hello, Lightbox Controller here!", this.element);

    FanwordLightbox.reloadLightbox('fanword-lightbox-image');
  }

}
